/**
 * @desc 导入SKU物流属性信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/logisticsSku/import`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
